export enum OnlineStatus {
    Unknown = 0,
    Offline = 1,
    Online = 2
}